interface QueueItem<T> {
  data: T;      // The actual data of the item
  index: number; // The index number of the item when it was added
}

export class LimitedQueue<T> {
  private queue:  QueueItem<T>[] = []
  private limit: number
  private index: number = 0

  constructor(limit: number) {
    this.limit = limit
  }

  // Push an element at the start of the queue
  push(element: T): void {
    this.queue.unshift({ data: element, index: this.index }) // Add element to the start
    if (this.queue.length > this.limit) {
      this.pop() // Automatically pop from end if size exceeds limit
    }
    this.index++
  }

  // Pop an element from the end of the queue
  private pop(): QueueItem<T> | undefined {
    return this.queue.pop()
  }

  // Get the current state of the queue
  getQueue(): QueueItem<T>[] {
    return [...this.queue]
  }

  clear(): void {
    this.queue = []
    this.index = 0
  }

  // Get the current size of the queue
  size(): number {
    return this.queue.length
  }
}
